import React, { useState, useEffect, useCallback, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import SwiperCore, { Autoplay } from 'swiper';
import { pexios, toast } from '../../utils/functions';
import { history } from '../../utils/variables';
import { Swiper, SwiperSlide } from 'swiper/react/swiper-react';
import Timer from '../../components/master/Timer';
import Moment from 'moment-jalaali';
import EventBus from '../../components/master/eventBus';
import horn from '../../assets/audio/horn.mp3';
import clockSpinner from '../../assets/images/clockSpinner.png';
import circleRoad from '../../assets/images/circleRoad.png';
import camaro from '../../assets/images/camaro.png';
import ambulance from '../../assets/images/icons/ambulance.png';
import police from '../../assets/images/icons/police-car.png';
import firefighter from '../../assets/images/icons/firefighter.png';
import warning from "../../assets/images/icons/warning.png";
import calm from "../../assets/images/icons/calm.png";
import triangle from "../../assets/images/icons/triangle.png";
import step from "../../assets/images/icons/stepsIcon1.png";
import {setLocation} from "../../redux/actions";
import { toast as toast2 } from 'react-toastify';
import { useTranslation } from 'react-i18next';

SwiperCore.use(Autoplay);
const params = {
    slidesPerView: 1,
    loop: true,
    autoplay: {
        delay: 5000,
    },
};

export default function Waiting() {
    const { t } = useTranslation();
    const { id } = useSelector((store) => store.routerData);
    const {location ,user} = useSelector(store=> store)

    const [accident, setAccident] = useState({});
    const [showTimer, setShowTimer] = useState(true);

    const findActiveAccident = useCallback(() => {
        pexios('/api/find_active_accident').then(res => {
            if (res.data)
                history.push('/complete');
        })
    }, []);

    useEffect(() => {
        pexios('/api/v2/get_accident', 'post', {accident_id: id , type : 'waiting'})
            .then(res => {
                setAccident(res.data.data);
                findActiveAccident();
            });
    }, [findActiveAccident, id]);

    function finishTimer() {
        setShowTimer(false);
        findActiveAccident();
    }
    function cancelAccident() {
        pexios('/api/cancel_accident','post',{ id })
            .then(()=>{
                history.replace('/');
            });
    }
    function broadcast(data) {
        const content = data.message;
        if (content.message === 'approve_accident' && parseInt(content.accident_id) === parseInt(id)) history.push('/complete');
    }
    function playNotification() {
        document.getElementById('notification').play();
    }
    ////
    const dispatch = useDispatch();
     
    const [permission,setPermission] = useState(false)
    const [userLocation,setUserLocation] = useState({
        lat:location.lat,
        lng:location.lng
    })
    const updateLocationTimer = useRef(null);
    let locationWatcherPosition;
    useEffect(()=>{
        locationWatcherPosition = navigator.geolocation.watchPosition((info)=>{
            setUserLocation({
                lat:info.coords.lat,
                lng:info.coords.lng
            })
        })
        const updateLocation = ()=> {
            
            pexios('api/update_location', 'post', { lat:userLocation.lat ,lng : userLocation.lng ,id:id})
            .then(res=>{
                if(res.data === 1)
                history.push('/complete')
                if(res.data === 7 && user.id !== 89957)
                history.push('/')
            })
            updateLocationTimer.current = setTimeout(()=>setPermission(prevState=>!prevState),10000)
        } 
        updateLocation()
        return () => {
            clearTimeout(updateLocationTimer.current)
            navigator.geolocation.clearWatch(locationWatcherPosition);
        }
    },[permission])
    let locationWatcher
    useEffect(() => {
        toast2.dismiss();
        if(navigator.permissions){
         navigator.permissions.query({name : "geolocation"})
            .then((result)=>{
                 if(result.state === "prompt"){
                    locationWatcher = navigator.geolocation.watchPosition((position)=>{
                        dispatch(setLocation({
                            lat: position.coords.latitude,
                            lng: position.coords.longitude,
                        }));
                    },()=>{
                        toast(t('Please turn on your Gps'),'error');
                    });
                }else if(result.state === "denied"){
                    toast(t('To accessing your GPS check setting'),'error');
                }
            })
        }else{
            locationWatcher = navigator.geolocation.watchPosition((position)=>{
                dispatch(setLocation({
                    lat: position.coords.latitude,
                    lng: position.coords.longitude,
                }));
            },()=>{
                toast(t('To accessing your GPS check setting'),'error');
            });
        }
        return () => {
            navigator.geolocation.clearWatch(locationWatcher);
        }
    }, []);
    const [lastUntil, setLastUntil] = useState(null);
    const [until, setUntil] = useState(Math.max(300, 0));
  
  const updateTimer = useCallback(() => {
    if (lastUntil === until) {
      return;
    }
    if (until === 1 || (until === 0 && lastUntil !== 1)) {
      //if (onFinish) {
        setTimeout(()=> {
          finishTimer();
        })
      //}
    }
    if (until === 0) {
      setLastUntil(0);
      setUntil(0);
    } else {
      setLastUntil(until);
      setUntil(prevState => (
          Math.max(0, prevState - 1)
      ));
    }
  }, [lastUntil, until]);
  const getTimeLeft = () => {
    return {
      seconds: until % 60,
      minutes: parseInt(until / 60, 10) % 60,
    };
  };
    useEffect(()=>{
        const timer = setInterval(updateTimer, 1000);
        return () => {
            clearInterval(timer)
        }
    },[])
    return (
        <div className='content waiting'>
            <EventBus onEvent={broadcast} />
            <audio id='notification'>
                <source src={horn} type='audio/mpeg' />
            </audio>
            {
                showTimer ?
                    <div className='clock-parent'>
                        <div className='clock-bg'>
                            <div className='rounded-wrapper'>
                                <img src={clockSpinner} alt='spinner' className='rounded' />
                            </div>
                            <i className='fas fa-phone-volume' />
                            
                            <div className='d-flex' style={{justifyContent:'center'}}>
                                <span className='cyan'> :{getTimeLeft().minutes}</span>
                                <span className='cyan'>{('0' + getTimeLeft().seconds).slice(-2)}</span>
                            </div>
                            {/* <Timer seconds={300} onFinish={finishTimer} /> */}
                        </div>
                    </div> :
                    <div className='mt50 text-center mb50'>
                        <button style={{width:'96px',fontSize:14}} className='btn btn-red btn-circle-left' onClick={cancelAccident}>{t('Reject')}</button>
                        <a style={{fontSize:14}} className='btn btn-green btn-circle-right' href='tel:02191065151'>{t('Contact with company')}</a>
                    </div>
            }
            <div className='text-center accident_time'>
                <i className='fas fa-hourglass-end' />
                <span>{t('Accident notification in the hour')}{Moment(accident.created_at).format('HH:mm')}</span>
            </div>
            <div className='mt20 road-slider'>
                <div className='road-wrapper'>
                    <img src={circleRoad} alt='circleRoad' className='circle-road' />
                    <img onClick={playNotification} src={camaro} alt='camaro' className='camaro' />
                </div>
                <div className='waiting-swiper'>
                    <div className='swiperParent' style={{width: '100%'}}>
                        <h4 dir='rtl'>{t('Dont forget')}!!</h4>
                        <Swiper {...params}>
                            <SwiperSlide>
                                {t('Emergency')} : 115
                                <img src={ambulance} alt='ambulance' />
                            </SwiperSlide>
                            <SwiperSlide>
                                {t('Police')} : 110
                                <img src={police} alt='police' />
                            </SwiperSlide>
                            <SwiperSlide>
                                {t('Fire station')} :125
                                <img src={firefighter} alt='firefighter' />
                            </SwiperSlide>
                            <SwiperSlide>
                                {t('Securing the scene of the accident')}
                                <img src={warning} alt='warning' />
                            </SwiperSlide>
                            <SwiperSlide>
                                {t('Keep calm')}
                                <img src={calm} alt='calm' />
                            </SwiperSlide>
                        </Swiper>
                    </div>
                </div>
            </div>
            <div className='steps'>
                <img className='step-border' src={triangle} alt='triangle' />
                <div className='icon-parent'>
                    <img src={step} alt='stepsIcon1' />
                </div>
                <p>{t('Wait for call')}</p>
            </div>
        </div>
    );

}
